import React, { useEffect, useRef, useState } from 'react'
import { FormattedMessage } from '~/translations/utils'
import { useDeviceChooserStore } from '../../service/DeviceChooser'
import { toast } from 'react-toastify'
import { notify } from '~/utils/notify'

type Props = { children: React.ReactNode }

type Status = 'waiting' | 'success' | 'fail'
type ErrorName =
  | 'AbortError'
  | 'NotAllowedError'
  | 'NotFoundError'
  | 'NotReadableError'
  | 'OverconstrainedError'
  | 'SecurityError'
  | 'TypeError'

const MicrophonePermission: React.FC<Props> = ({ children }) => {
  const [status, setStatus] = useState<Status>('waiting')
  const [errorName, setErrorName] = useState<ErrorName>()

  const store = useDeviceChooserStore()
  const storeRef = useRef(store)
  storeRef.current = store

  useEffect(() => {
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(async () => {
        setStatus('success')

        const devices = await navigator.mediaDevices.enumerateDevices()

        const store = storeRef.current

        if (store.input && !devices.find(d => d.deviceId == store.input)) {
          notify(
            intl.formatMessage({
              id: 'mic perm / saved device not found / input',
            }),
            'warning',
            { autoClose: false }
          )

          store.setInput(null)
        }

        if (store.output && !devices.find(d => d.deviceId == store.output)) {
          notify(
            intl.formatMessage({
              id: 'mic perm / saved device not found / output',
            }),
            'warning',
            { autoClose: false }
          )

          store.setOutput(null)
        }
      })
      .catch((e: DOMException) => {
        console.error(e)

        setErrorName(e.name as ErrorName)
        setStatus('fail')
      })
  }, [])

  switch (status) {
    case 'waiting':
      return (
        <div className="micPerm">
          <div>
            <FormattedMessage id="mic perm / waiting" />
          </div>
        </div>
      )

    case 'success':
      return <>{children}</>

    case 'fail':
      return (
        <div className="micPerm">
          <div>
            {(() => {
              switch (errorName) {
                case 'AbortError':
                  return <FormattedMessage id="mic perm / fail / AbortError" />
                case 'NotAllowedError':
                  return (
                    <FormattedMessage id="mic perm / fail / NotAllowedError" />
                  )
                case 'NotFoundError':
                  return (
                    <FormattedMessage id="mic perm / fail / NotFoundError" />
                  )
                case 'NotReadableError':
                  return (
                    <FormattedMessage id="mic perm / fail / NotReadableError" />
                  )
                case 'OverconstrainedError':
                  return (
                    <FormattedMessage id="mic perm / fail / OverconstrainedError" />
                  )
                case 'SecurityError':
                  return (
                    <FormattedMessage id="mic perm / fail / SecurityError" />
                  )
                // case 'TypeError':
                //   return <FormattedMessage id="mic perm / fail / TypeError" />
              }
            })()}
          </div>
        </div>
      )
  }
}

export default MicrophonePermission
